import { render, staticRenderFns } from "./CustomPicker.vue?vue&type=template&id=054b71f8"
import script from "./CustomPicker.vue?vue&type=script&lang=js"
export * from "./CustomPicker.vue?vue&type=script&lang=js"
import style0 from "./CustomPicker.vue?vue&type=style&index=0&id=054b71f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports